export default "__VITE_ASSET__pSkJjIha__"